import isUndefined from 'lodash/isUndefined';
import isEmpty from 'lodash/isEmpty';
import values from 'lodash/values';
import { showChangedToastMessage } from '@Containers/ToastMessages/ChangedToastMessage/ChangedToastMessageActions';
import { getTitleAndContentForToastMessage } from './components/sections/PreferencesPreferredSuppliersSection/Components/PreferredSuppliersToastMessage';

// eslint-disable-next-line import/prefer-default-export
export const showSupplierPreferencesChangedToastMessage = ({ optionsMap = {}, originalCheckedMap = {}, checkedMap = {} }) => {
  return () => {
    const optionsList = values(optionsMap);

    const { added: addedSuppliers, deleted: deletedSuppliers } = optionsList.reduce(
      ({ added, deleted }, option) => {
        const { name } = option;
        if (!isUndefined(checkedMap[name]) && checkedMap[name] !== originalCheckedMap[name]) {
          return checkedMap[name]
            ? {
                added: added.concat([option]),
                deleted,
              }
            : {
                added,
                deleted: deleted.concat([option]),
              };
        }
        return {
          added,
          deleted,
        };
      },
      {
        added: [],
        deleted: [],
      }
    );

    if (!isEmpty(addedSuppliers) || !isEmpty(deletedSuppliers)) {
      const { title, content } = getTitleAndContentForToastMessage({ addedSuppliers, deletedSuppliers });
      showChangedToastMessage({ title, content });
    }
  };
};
